import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "import"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "吕楠中医叫号系统", -1);
const _hoisted_4 = {
  key: 1,
  class: "excel-import"
};
const _hoisted_5 = {
  class: "sub-list"
};
const _hoisted_6 = {
  class: "sub-title"
};
const _hoisted_7 = {
  class: "sub-content"
};
const _hoisted_8 = {
  class: "left"
};
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = {
  class: "info"
};
const _hoisted_11 = {
  class: "right"
};
import { ref } from 'vue';
import * as XLSX from 'xlsx';
import avatar from '@/assets/avatar.png';
export default {
  __name: 'index',
  setup(__props) {
    const dataList = ref([]);
    const showUploader = ref(true);
    const handleFileUpload = ({
      file
    }) => {
      const reader = new FileReader();
      reader.onload = e => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {
          type: 'array'
        });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        const _data = json.reduce((acc, item) => {
          // 获取每个项的"Selected Time"
          const key = item['已选时间'];
          if (!acc[key]) {
            acc[key] = [];
          }
          // 将需要的字段放入对应的分组
          acc[key].push({
            Name: item['姓名'],
            Gender: item['性别'],
            Phone_Number: item['手机号'],
            Selected_Time: item['已选时间'],
            Status: 0,
            // 0 未叫号 1 正在叫号 2 已叫号
            Call_Time: '' // 叫号时间
          });
          return acc;
        }, {});
        dataList.value = _data;
        showUploader.value = false;
      };
      reader.readAsArrayBuffer(file);
    };
    const current = ref({});
    const loading = ref(false);
    const handleCall = item => {
      if (loading.value) return;
      loading.value = true;
      item.Status = 1;
      item.loading = true;
      current.value = item;
      const speechSynthesis = window.speechSynthesis;
      // 创建一个语音合成对象
      const synth = new SpeechSynthesisUtterance();
      // 设置要合成的文本
      synth.text = ` 请 ${item.Name} 就诊`;
      // 设置语音的语速
      synth.rate = 0.8;
      // 设置语音的语调
      synth.pitch = 1;
      // 设置语音的音量
      synth.volume = 1;
      // 播放语音
      speechSynthesis.speak(synth);
      speechSynthesis.speak(synth);
      // 模拟语音播报
      setTimeout(() => {
        item.loading = false;
        item.Status = 2;
        loading.value = false;
      }, 5000);
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_uploader = _resolveComponent("van-uploader");
      return _openBlock(), _createElementBlock("div", null, [showUploader.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        src: _unref(avatar),
        alt: ""
      }, null, 8, _hoisted_2), _hoisted_3, _createVNode(_component_van_uploader, {
        accept: ".xlsx",
        reupload: "",
        "after-read": handleFileUpload,
        class: "upload"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_button, {
          icon: "plus",
          type: "primary",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("导入数据")]),
          _: 1
        })]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (sub, key, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "sub-item"
        }, [_createElementVNode("div", _hoisted_6, _toDisplayString(key), 1), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sub, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["data-item", {
              status_0: item.Status === 0,
              status_1: item.Status === 1,
              status_2: item.Status === 2
            }])
          }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(index + 1) + " : " + _toDisplayString(item.Name), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.Gender) + " - " + _toDisplayString(item.Phone_Number), 1)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_button, {
            loading: item.loading,
            type: "primary",
            "loading-text": "呼叫中",
            style: {
              "width": "100%",
              "height": "100%",
              "line-height": "2",
              "font-size": "32px",
              "display": "flex",
              "align-items": "center"
            },
            onClick: $event => handleCall(item)
          }, {
            default: _withCtx(() => [_createTextVNode("叫号")]),
            _: 2
          }, 1032, ["loading", "onClick"])])], 2);
        }), 128))])]);
      }), 128))])]))]);
    };
  }
};